/**
 * system (시스템) orval 래퍼
 */
import { customInstance } from "../custom-instance";
// ── API 함수 ──
export async function analyzeOrphanFiles(params) {
    return customInstance({
        url: "/admin/orphan-files/analyze",
        method: "GET",
        params,
    });
}
export async function deleteOrphanFiles(keys) {
    return customInstance({
        url: "/admin/orphan-files",
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        data: { keys },
    });
}
export async function getPageResourceList() {
    return customInstance({
        url: "/page-resource",
        method: "GET",
    });
}
// ── SDK 객체 ──
export const systemApi = {
    analyzeOrphanFiles,
    deleteOrphanFiles,
    getPageResourceList,
};
